module.exports = __webpack_public_path__ + "static/media/sanmiO.d6139839.svg";